module.exports = __webpack_public_path__ + "static/imgs/complaintSupervision.9ca6c48.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/complaintSupervision.jpg
// module id = sj5/
// module chunks = 1